import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(private http: HttpClient) { }

  getCSOList(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}helpCenter`);
  }

  getCSOById(id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}helpCenter/${id}`);
  }

  saveCSO(obj): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${environment.apiUrl}helpCenter`, obj);
  }

  updateCSO(obj): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`${environment.apiUrl}helpCenter`, obj);
  }

  deleteCSO(id: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${environment.apiUrl}helpCenter/${id}`);
  }

  getChaosResults(body) {
    return this.http.post<ApiResponse>(`${environment.apiUrl}chaosSimulator/questionnaires`, body);
  }

  saveChaosResult() {
    return this.http.get<ApiResponse>(`${environment.apiUrl}chaosSimulator/questionnaires`);
  }

}
